import "./OurStandoutFeatures.css";

const OurStandoutFeatures = ({ data }: { data: any }) => {
  return (
    <section className="standout-features-section max-w-screen-xl mx-auto py-10">
      <h2 className="standout-features-title">{data?.header}</h2>
      <div className="features-container">
        {data?.features.map((feature: any) => (
          <div
            className="feature-card"
            key={feature?.id}
            style={{ backgroundImage: `url(${feature?.image})` }}
          >
            <div className="feature-overlay">
              <h3 className="feature-heading">{feature?.title}</h3>
              <p className="feature-description">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurStandoutFeatures;
